import { render } from "./SocialMediaPlug.vue?vue&type=template&id=fda78328"
import script from "./SocialMediaPlug.vue?vue&type=script&lang=js"
export * from "./SocialMediaPlug.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__